"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _utils = require("../../utils");
var _composeStencilComponent = require("../../utils/composeStencilComponent");
var _constants = require("./constants");
var _helperComponents = require("./helperComponents");
var _react2 = require("@emotion/react");
const GridItem = _ref => {
  let {
    children,
    lg,
    md,
    sm,
    ...props
  } = _ref;
  return (0, _react2.jsx)(_helperComponents.GridBase, (0, _extends2.default)({
    lg: lg,
    md: md,
    sm: sm,
    className: _constants.GRID_ITEM_CLASS_NAME
  }, (0, _utils.pickDataProps)(props)), children);
};
var _default = exports.default = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: GridItem,
  displayName: 'GridItem',
  description: 'Component which determines the number of columns which will be used by child components per viewport breakpoint.',
  propTypes: {
    lg: _stencilReactDesc.PropTypes.oneOf((0, _utils.getRangeArray)(1, _constants.GRID_COLUMNS.lg)).description('Indicates how many columns are occupied by the component on lg breakpoint'),
    md: _stencilReactDesc.PropTypes.oneOf((0, _utils.getRangeArray)(1, _constants.GRID_COLUMNS.md)).description('Indicates how many columns are occupied by the component on md breakpoint'),
    sm: _stencilReactDesc.PropTypes.oneOf((0, _utils.getRangeArray)(1, _constants.GRID_COLUMNS.sm)).description('Indicates how many columns are occupied by the component on sm breakpoint')
  },
  defaultProps: {
    ..._constants.gridDefaultProps
  }
});